import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";

@Component({
  selector: "app-import-notice-csv",
  template: `<input (change)="uploadFile($event)" type='file' class='hidden' id="input-upload-notice-csv" accept=".csv">`,
  styles: [],
  standalone: false,
})
export class ImportNoticeCSVComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(private host: ElementRef<HTMLElement>,private message:Message,private rest:RestService) {}

  ngOnInit(): void {
    let myInput = document.getElementById('input-upload-notice-csv')
    if(myInput){
      myInput.click()
    }
    setTimeout(() => {
      this.autoDestory()
    }, 1);
  }

  uploadFile(event:any){
    if(event?.target?.files ){
      if(event?.target.files[0].type.includes('/csv')){
        let myForm = new FormData()
        myForm.append('file',event?.target.files[0] )
        this.rest.post('/csv/upload',myForm).subscribe({
          next:(value)=> {
            this.message.showMessage("Bando importato con successo",'success')
            this.fatherContaierRef.getTableData();
          },
          error:(value)=> {
            this.message.showMessage("Errore nell'importazione del bando",'error')
          },
        })
      }else{
        this.message.showMessage('Puoi caricare solo csv','error')
      }
    }
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
